module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "RentSpace"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column is-8 content"
  }, _vm._l((_vm.content), function(line) {
    return _c('p', {
      staticClass: "has-text-white is-size-3"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(line)
      }
    })])
  }), 0)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column is-8 content"
  }, [_c('h1', {
    staticClass: "title has-text-white"
  }, [_vm._v("\n        Equipment in our space for your event\n      ")]), _vm._v(" "), _vm._l((_vm.equipment), function(eq) {
    return _c('ul', {
      staticClass: "has-text-white is-size-4"
    }, [_c('li', [_c('p', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(eq)
      }
    })])])])
  })], 2)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "columns is-centered"
  }, _vm._l((_vm.href.iframes), function(frame) {
    return _c('div', {
      staticClass: "column is-6 contains-iframe-to-center"
    }, [_c('ImageFrame', {
      key: frame,
      attrs: {
        "url": frame
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column is-8 content"
  }, [_c('h1', {
    staticClass: "title has-text-white"
  }, [_vm._v("\n        If you're organizing an event in our space\n      ")]), _vm._v(" "), _c('ul', {
    staticClass: "has-text-white is-size-6"
  }, [_c('li', [_c('p', [_vm._v("\n          consider including this text in the description of your event:\n        ")]), _vm._v(" "), _c('p'), _c('blockquote', {
    staticClass: "quote-to-include-in-event has-text-white"
  }, [_vm._v("\n            🌈 You can support Progressbar 👉 "), _c('router-link', {
    staticClass: "quote-link",
    attrs: {
      "to": "/pay"
    }
  }, [_vm._v("https://cowork.progressbar.sk/pay")]), _c('br'), _vm._v("\n            🌈 Progressbar Coworking in Downtown 👉 "), _c('a', {
    staticClass: "quote-link",
    attrs: {
      "href": "https://cowork.progressbar.sk"
    }
  }, [_vm._v("https://cowork.progressbar.sk")]), _c('br'), _vm._v("\n            🌈 Join Our Cowork Channel on Telegram 👉 "), _c('a', {
    staticClass: "quote-link",
    attrs: {
      "href": "https://t.me/coworkprogressbar"
    }
  }, [_vm._v("https://t.me/coworkprogressbar")])], 1), _vm._v(" "), _c('p')]), _vm._v(" "), _vm._m(3)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column is-9 content"
  }, [_c('h1', {
    staticClass: "title has-text-white is-size-1"
  }, [_vm._v("\n        Rent a Space for Your Events\n      ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/eventspace/event_space_chairs.jpg",
      "loading": "lazy",
      "alt": "meetup space in bratislava downtown"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/eventspace/codebeer.jpg",
      "loading": "lazy",
      "alt": "meetup space in bratislava downtown"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column is-9 content"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/eventspace/mlmu_december.jpg",
      "loading": "lazy",
      "alt": "machine learning bratislava meetup in coworking space"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/community/IMG_20191017_190905.jpg",
      "loading": "lazy",
      "alt": "study group in coworking"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column is-8 content"
  }, [_c('h1', {
    staticClass: "title has-text-white"
  }, [_c('p', [_vm._v("Do you have any other questions about our venue?\n          "), _c('br'), _vm._v("Contact us at\n          "), _c('a', {
    attrs: {
      "href": "mailto:info@progressbar.sk?Subject=Looking%20for%20venue%20for%20my%20event"
    }
  }, [_vm._v("info@progressbar.sk")]), _vm._v(",\n          directly through "), _c('a', {
    attrs: {
      "href": "https://m.me/progressbar"
    }
  }, [_vm._v("Facebook Messenger")]), _vm._v(" or\n          through our "), _c('a', {
    attrs: {
      "href": "https://t.me/coworkprogressbar"
    }
  }, [_vm._v("Telegram channel.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("\n        if your event is on Facebook, send a \"co-host\" request to "), _c('a', {
    attrs: {
      "href": "https://www.facebook.com/progressbar/",
      "target": "_blank"
    }
  }, [_vm._v("Progressbar")]), _vm._v(" for greater pull and easier administration 🤗\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22a079c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RentSpace.vue
// module id = 242
// module chunks = 1